import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dudaga-botoks-uygulamasi-nedir-nasil-yapilir/page.tsx");
